module.exports = __webpack_public_path__ + "static/alfa-80411d05a24e39344c3816eaea748af7.svg";